import { parseBooleanValue } from "../../util";
import { IIndexTypeCategory } from "../model/IndexTypeCategory";

const IndexTypeCategoryParamMapper = (item: IIndexTypeCategory) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid)
  };
};

export default IndexTypeCategoryParamMapper;
